// @ts-nocheck

import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, TextField, Typography, InputAdornment } from "@mui/material"; // Ensure TextField and InputAdornment are imported
import dayjs from "dayjs";
import calendarDate from "../../assets/calendarDate.png"; // Import your custom calendar image
import { useSelector } from "react-redux";

const CommonDatePicker = ({
  label,
  value,
  onChange,
  error,
  helperText,
  touched,
  maxDate,
  sx,
  size, disabled = false,disableFuture = false
}) => {
  // Function to handle manual input
  const { loginInvestorId } = useSelector((state: any) => state.user);

  const handleManualInput = (event) => {
    const inputValue = event.target.value;
    const formattedDate = dayjs(inputValue, "YYYY-MM-DD", true); // You can change the date format according to your requirement
    if (formattedDate.isValid()) {
      onChange(formattedDate);
    } else {
      onChange(null); // If the input is invalid, clear the value
    }
  };

  return (
    <Box sx={{...sx}}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          disableFuture={disableFuture}
          maxDate={maxDate}
          disabled={disabled}
          value={value ? dayjs(value) : null} // Convert value to Dayjs object if not null
          onChange={onChange} // Trigger the onChange when the date is updated
          sx={{
            width: "100%",
            border:
              (touched || (loginInvestorId && helperText)) && error
                ? "1px solid red"
                : undefined,
            borderRadius: 1,
            label: {
              top: value || size == "big" ? 0 : -6,
              color :(touched || (loginInvestorId && helperText)) && error
                ? "#d32f2f"
                : undefined,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              top: "0px", // Label position when focused
              border:
                (touched || (loginInvestorId && helperText)) && error
                  ? "1px solid red"
                  : undefined,
              borderRadius: 1,
            },
            "& .MuiInputBase-inputAdornedEnd": {
              padding: size !== "big" ? "8.85px 14px" : "auto",
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: (touched || (loginInvestorId && helperText)) && error ? "none" : "1px solid rgba(0, 0, 0, 0.23)"
            }
          }}
          size={size}
          renderInput={(params) => (
            <TextField
              {...params}
              size={size}
              variant="outlined"
              error={error ? true : false} // Show error state if error is true
              helperText={error ? helperText : ""} // Show helper text if error is true
              onInput={handleManualInput} // Handle input manually
              components={{
                OpenPickerIcon: () => (
                  <img
                    src={calendarDate}
                    alt="calendar"
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                ),
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    {/* Ensure the image has a reasonable size */}
                    <img
                      src={calendarDate}
                      alt="calendar"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: "pointer",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </LocalizationProvider>
      {(touched || (loginInvestorId && helperText)) && error && (
        <Typography variant="body1" color="#d32f3f" fontSize={"0.75rem"} mx={2} mt={.5}>
          {helperText ? helperText : error}
        </Typography>
      )}
    </Box>
  );
};

export default CommonDatePicker;
